import { axios_get } from "./axios";

export const getSign = () => {
    let url = "https://vipapi.app.cctv.com/cmos-facade-server/openapi/generateRequestReq?appId=7314085c95a6c60943ef446060cc0658f03df552";
    // let url = "http://10.51.28.5:8081/cmos-facade-server/openapi/generateRequestReq?appId=7314085c95a6c60943ef446060cc0658f03df552";
    return axios_get(url).then(res=>{
        if(res && res.code === 10000){
            localStorage.setItem('token',res.data.data.token)
            localStorage.setItem('header',JSON.stringify(res.data.data.header));
            return Promise.resolve(res);
        }
    })
}

export const getSource = () =>{
    let arr = [
        'Android','iPhone','Windows','iPad','Windows','OTT'
    ];
    let ua = navigator.userAgent;
    for(let i in arr){
        if(ua.indexOf(arr[i]) >= 0){
            return i;
        }
    }
    return 3;
}

export const setUserReq = (info) =>{
    sessionStorage.setItem("userReq",JSON.stringify(info));
}

export const getUserReq = () => {
    let info = sessionStorage.getItem("userReq");
    return info ? JSON.parse(info) : {};
}